module.exports = __webpack_public_path__ + "0640bc4e098c7bf1ca5ea40d0c41b9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/guenole_flat.jpg
// module id = 706
// module chunks = 0